(function () {
  "use strict";

  function criarMenuAtendimento() {
    const html = `
            <div class="menu-atendimento-container">
                <div class="mensagem-atendimento">
                    Não fique com dúvida!<br><strong>Fale com a gente</strong>
                </div>
                <button class="btn-atendimento-flutuante" id="btnAtendimento" aria-label="Abrir menu de atendimento">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H6L4 18V4H20V16Z" fill="white"/>
                    </svg>
                </button>
            </div>

            <div class="overlay-atendimento" id="overlayAtendimento"></div>

            <div class="menu-lateral-atendimento" id="menuAtendimento">
                <div class="menu-header">
                    <h2>Fale conosco</h2>
                    <button class="btn-fechar" id="btnFechar" aria-label="Fechar menu de atendimento">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#222222"/>
                        </svg>
                    </button>
                </div>
                <div class="menu-conteudo">
                    <div class="menu-conteudo__item__btn-whats menu-conteudo__item">
                        <a href="https://wa.me/5516997622931" target="_blank" class="menu-conteudo__item__btn-whats__link"> <svg xmlns="http://www.w3.org/2000/svg" width="27" height="28" viewBox="0 0 27 28" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M26.766 14.0384C26.7447 16.3138 26.1337 18.5448 24.9929 20.5136C23.852 22.4824 22.2202 24.1218 20.2567 25.2717C18.2932 26.4216 16.0651 27.0429 13.7898 27.0747C11.5146 27.1066 9.26994 26.548 7.27501 25.4534L0 27.7654L2.371 20.7704C1.13501 18.7427 0.482725 16.4132 0.486008 14.0384C0.486008 10.5535 1.8704 7.21128 4.33463 4.74706C6.79885 2.28283 10.1411 0.898438 13.626 0.898438C17.111 0.898438 20.4532 2.28283 22.9174 4.74706C25.3816 7.21128 26.766 10.5535 26.766 14.0384ZM13.627 3.07643C10.7092 3.06792 7.90715 4.21737 5.83588 6.27252C3.7646 8.32767 2.5933 11.1206 2.57901 14.0384C2.57651 16.3498 3.31225 18.6015 4.679 20.4654L3.29901 24.5354L7.54401 23.1864C8.97122 24.1463 10.6038 24.7579 12.3104 24.9719C14.017 25.1859 15.7501 24.9964 17.3701 24.4186C18.9902 23.8408 20.452 22.8909 21.638 21.6452C22.824 20.3995 23.7011 18.8929 24.1988 17.2465C24.6965 15.6 24.8008 13.8598 24.5034 12.1657C24.206 10.4717 23.5151 8.87102 22.4864 7.49258C21.4577 6.11415 20.1198 4.99638 18.5804 4.2292C17.041 3.46202 15.343 3.06684 13.623 3.07544L13.627 3.07643ZM20.262 17.0414C20.181 16.9084 19.962 16.8284 19.645 16.6684C19.328 16.5084 17.738 15.7354 17.445 15.6294C17.152 15.5234 16.934 15.4694 16.72 15.7884C16.506 16.1074 15.888 16.8284 15.699 17.0414C15.51 17.2544 15.324 17.2814 14.999 17.1214C14.0501 16.747 13.1734 16.2107 12.408 15.5364C11.7053 14.8907 11.1015 14.1451 10.616 13.3234C10.429 13.0044 10.597 12.8314 10.757 12.6714C10.902 12.5274 11.08 12.2984 11.241 12.1124C11.3734 11.9504 11.4818 11.7702 11.563 11.5774C11.6059 11.4895 11.626 11.3922 11.6212 11.2945C11.6165 11.1967 11.5872 11.1018 11.536 11.0184C11.456 10.8594 10.811 9.28643 10.543 8.64543C10.275 8.00443 10.007 8.03044 9.81801 8.03044C9.63874 8.03875 9.46011 8.05744 9.283 8.08644C8.9379 8.12725 8.61169 8.26605 8.343 8.48643C7.97965 8.82746 7.69167 9.24074 7.49757 9.69971C7.30348 10.1587 7.20757 10.6532 7.216 11.1514C7.32193 12.3562 7.77878 13.5036 8.53001 14.4514C9.8704 16.5476 11.7774 18.2209 14.03 19.2774C17.305 20.5564 17.305 20.1294 17.895 20.0774C18.3438 19.9913 18.7694 19.8115 19.144 19.5498C19.5186 19.288 19.8338 18.9502 20.069 18.5584C20.2795 18.0816 20.3452 17.5533 20.258 17.0394L20.262 17.0414Z" fill="#4F9F00"></path>
                      </svg> NOS CHAME NO WHATS</a>
                    </div>
                    <div class="menu-conteudo__item">
                        <p>Prefere o telefone? Ligue pra gente!</p>
                        <span data-wsjs-infos="mainPhone">
                            {{value}}
                        </span>
                    </div>
                    <div class="menu-conteudo__item">
                        <p>Não gosta de ligar? Mande um e-mail.</p>
                        <span data-wsjs-infos="mainEmail">
                            {{value}}
                        </span>
                    </div>
                    <div class="menu-conteudo__item">
                        <p>Fique atento em nosso horário de atendimento. Afinal, a gente também gosta de brincar :)</p>
                                  <div data-wsjs-container class="commercialHours-container">
            <span data-wsjs-infos="commercialHours" class="commercialHours">
              <span>
                <!-- <span data-wsjs-icon="watch"></span> -->
              </span>
              {{value}}
            </span>
          </div>

                    </div>
                    <div class="menu-conteudo__item">
                        <p>Não acredito que ainda não segue a gente!</p>
                        <span class="social-footer" data-wsjs-infos="socialMidia"></span>
                    </div>
                </div>
            </div>

        `;

    const container = document.createElement("div");
    container.innerHTML = html;
    document.body.appendChild(container);
  }

  function inicializarEventos() {
    const btnAtendimento = document.getElementById("btnAtendimento");
    const btnFechar = document.getElementById("btnFechar");
    const menuAtendimento = document.getElementById("menuAtendimento");
    const overlayAtendimento = document.getElementById("overlayAtendimento");

    function abrirMenu() {
      menuAtendimento.classList.add("aberto");
      overlayAtendimento.classList.add("ativo");
      document.body.style.overflow = "hidden";
    }

    function fecharMenu() {
      menuAtendimento.classList.remove("aberto");
      overlayAtendimento.classList.remove("ativo");
      document.body.style.overflow = "";
    }

    if (btnAtendimento) {
      btnAtendimento.addEventListener("click", abrirMenu);
    }

    if (btnFechar) {
      btnFechar.addEventListener("click", fecharMenu);
    }

    if (overlayAtendimento) {
      overlayAtendimento.addEventListener("click", fecharMenu);
    }

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && menuAtendimento.classList.contains("aberto")) {
        fecharMenu();
      }
    });
  }

  // Inicializar quando o DOM estiver carregado
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      criarMenuAtendimento();
      inicializarEventos();
    });
  } else {
    criarMenuAtendimento();
    inicializarEventos();
  }
})();
